import { clevorImage, heroImage, machinistImage, shopSignImage } from "@/lib/images";
import type { PictureAsset } from "@/lib/images";

export type GalleryPhoto = {
  image: PictureAsset;
  alt: string;
  title: string;
  caption: string;
  width: number;
  height: number;
  featured: boolean;
  imgClassName?: string;
};

export const galleryPhotos: GalleryPhoto[] = [
  {
    image: clevorImage,
    alt: "Blue Clevor engine with aluminum Cleveland heads, Trick Flow water neck, and gold rockers on an engine stand",
    title: "Clevor Engine",
    caption: "Assembled Cleveland + Windsor build on the stand",
    width: clevorImage.width,
    height: clevorImage.height,
    featured: true,
  },
  {
    image: heroImage,
    alt: "Engine block being precision machined at Champion Automotive Machine Shop",
    title: "Block Work",
    caption: "Cylinder machining in progress",
    width: heroImage.width,
    height: heroImage.height,
    featured: false,
  },
  {
    image: machinistImage,
    alt: "Measuring a crankshaft journal with a micrometer",
    title: "Inspection",
    caption: "Precision measurement on every job",
    width: machinistImage.width,
    height: machinistImage.height,
    featured: false,
  },
  {
    image: shopSignImage,
    alt: "Champion Automotive Machine Shop roadside sign in Enterprise, Alabama",
    title: "The Shop",
    caption: "Enterprise, Alabama",
    width: shopSignImage.width,
    height: shopSignImage.height,
    featured: false,
    imgClassName: "object-[center_28%]",
  },
];
